import { atom } from 'jotai'

export const darkModeAtom = atom(false)
